// ======================================================================
// 📁 File: BOQLineTable.jsx
// ======================================================================

import React, { useState } from "react";
import axiosClient from "../../../../../api/axiosClient";

import BOQLineRow from "./BOQLineRow";
import MaterialSelector from "./MaterialSelector"; // ✅ NEW

export default function BOQLineTable({
  value = [],
  onChange,
  readOnly = false,
  boqId,
}) {
  // ------------------------------------------------------------
  // ✅ NEW STATE (PROCESS SELECTION)
  // ------------------------------------------------------------
  const [processSelection, setProcessSelection] = useState(null);

  // ------------------------------------------------------------
  // ADD NEW LINE
  // ------------------------------------------------------------
  const addLine = async () => {
    if (!boqId) {
      alert("Please save BOQ header first");
      return;
    }

    try {
      const res = await axiosClient.post(
        `/api/ppe/orders/boq-masters/${boqId}/lines`,
        {
          material_type: "RAW",
          quantity_per_unit: 1,
        }
      );

      onChange([...value, res.data.data]);
    } catch (err) {
      alert(
        err?.response?.data?.message ||
          "Failed to add BOQ line"
      );
    }
  };

  // ------------------------------------------------------------
  // UPDATE LINE
  // ------------------------------------------------------------
  const updateLine = (updatedRow) => {
    const updated = value.map((r) =>
      r.id === updatedRow.id ? updatedRow : r
    );
    onChange(updated);
  };

  // ------------------------------------------------------------
  // DELETE LINE
  // ------------------------------------------------------------
  const deleteLine = async (row) => {
    if (!window.confirm("Delete this line?")) return;

    try {
      await axiosClient.delete(
        `/api/ppe/orders/boq-master-lines/${row.id}`
      );

      onChange(value.filter((r) => r.id !== row.id));
    } catch (err) {
      alert("Failed to delete BOQ line");
    }
  };

  // ------------------------------------------------------------
  // ✅ PROCESS CHANGE (UPDATED)
  // ------------------------------------------------------------
  const onProcessChange = async (row, field, valueFlag) => {
    if (!boqId) return;

    const processMap = {
      painting_required: "PAINT",
      insulation_required: "INSULATION",
      fabrication_required: "FABRICATION",
    };

    const processType = processMap[field];

    // ----------------------------------------------------------
    // REMOVE CHILD
    // ----------------------------------------------------------
    if (valueFlag === false) {
      const child = value.find(
        (r) =>
          r.parent_line_id === row.id &&
          r.process_type === processType
      );

      if (child) {
        try {
          await axiosClient.delete(
            `/api/ppe/orders/boq-master-lines/${child.id}`
          );

          onChange(
            value.filter((r) => r.id !== child.id)
          );
        } catch (err) {
          alert("Failed to remove process line");
        }
      }
      return;
    }

    // ----------------------------------------------------------
    // ✅ OPEN SELECTOR INSTEAD OF DIRECT ADD
    // ----------------------------------------------------------
    if (valueFlag === true) {
      setProcessSelection({
        parentRow: row,
        processType,
      });
    }
  };

  // ------------------------------------------------------------
  // ✅ HANDLE MATERIAL SELECT
  // ------------------------------------------------------------
  const onProcessMaterialSelect = async ({
    id,
    processType,
  }) => {
    if (!processSelection) return;

    const parentRow = processSelection.parentRow;

    try {
      const res = await axiosClient.post(
        `/api/ppe/orders/boq-masters/${boqId}/lines`,
        {
          material_type: "RAW",
          raw_material_id: id,
          quantity_per_unit: 1,

          parent_line_id: parentRow.id,
          process_type: processType,
          is_auto_generated: true,
        }
      );

      onChange([...value, res.data.data]);

      // close selector
      setProcessSelection(null);
    } catch (err) {
      alert("Failed to add process line");
    }
  };

  // ------------------------------------------------------------
  // RENDER
  // ------------------------------------------------------------
  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between">
        <strong>BOQ Materials</strong>

        {!readOnly && (
          <button
            className="btn btn-sm btn-primary"
            onClick={addLine}
          >
            + Add Line
          </button>
        )}
      </div>

      <div className="card-body p-0">
        <table className="table table-bordered mb-0">
          <thead className="table-light">
            <tr>
              <th style={{ width: 60 }}>Seq</th>
              <th style={{ width: 160 }}>
                Material Type
              </th>
              <th>Material</th>
              <th style={{ width: 120 }}>UOM</th>
              <th style={{ width: 130 }}>
                Qty / Unit
              </th>
              <th style={{ width: 110 }}>
                Scrap %
              </th>

              <th style={{ width: 120 }}>
                Painting
              </th>
              <th style={{ width: 120 }}>
                Insulation
              </th>
              <th style={{ width: 120 }}>
                Fabrication
              </th>

              <th>Remarks</th>
              <th style={{ width: 80 }}>
                Action
              </th>
            </tr>
          </thead>

          <tbody>
            {value.length === 0 && (
              <tr>
                <td
                  colSpan={11}
                  className="text-center text-muted"
                >
                  No materials added
                </td>
              </tr>
            )}

            {value.map((row, index) => (
              <BOQLineRow
                key={row.id}
                index={index}
                row={row}
                readOnly={readOnly}
                onChange={(updated) =>
                  updateLine(updated)
                }
                onDelete={() => deleteLine(row)}
                onProcessChange={onProcessChange}
              />
            ))}
          </tbody>
        </table>

        {/* =========================================================
           ✅ PROCESS MATERIAL SELECTOR (INLINE)
           ========================================================= */}
        {processSelection && (
          <div
            style={{
              padding: 10,
              borderTop: "1px solid #eee",
              background: "#fafafa",
            }}
          >
            <strong>
              Select {processSelection.processType} Material:
            </strong>

            <MaterialSelector
              materialType="RAW"
              value={{}}
              processMode={true}
              processType={processSelection.processType}
              onProcessSelect={onProcessMaterialSelect}
            />

            <button
              className="btn btn-sm btn-secondary mt-2"
              onClick={() => setProcessSelection(null)}
            >
              Cancel
            </button>
          </div>
        )}
      </div>
    </div>
  );
}